import styled from "styled-components";

export const Container = styled.div`
  // height: 90vh;
  margin-bottom: 20px;
  @media screen and (max-width: 480px) {
    margin-bottom: 0px;
  }
`;
export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 480px) {
    align-items: center;
  }
`;
export const Title = styled.p`
  font-weight: 400;
  font-size: 60px;
  line-height: 100px;
  letter-spacing: 0.3em;
  @media screen and (max-width: 480px) {
    font-size: 35px;
    line-height: 70px;
    padding-left: 5px;
  }
`;
export const BtnDiv = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 480px) {
    padding-right: 5px;
  }
`;
export const Button = styled.button`
  height: 45px;
  width: 100px;
  border: none;
  background: #2f3133;
  color: white;
  cursor: pointer;
  @media screen and (max-width: 480px) {
    height: 28px;
    width: 70px;
    font-size: 11px;
  }
`;
export const Bottom = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 480px) {
    margin-top: 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
